import { Box, Grid2 } from '@mui/material'
import Heading from '../../shared/utils/Heading'
import CustomDivider from '../../shared/utils/CustomDivider'
import { StarBulletsPointsWithHeading } from '../../shared/components/StarBulletsPoints'
import { EducationForLifeImages } from '../../assets/img/educationforlife/EducationForLifeImages'
import { getImageUrl } from '../../shared/utils/getImageUrl'

export const ImageBox = ({ img }) => (
    <Grid2
        size={{ xs: 12, sm: 6, md: 4 }}
        sx={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            borderRadius: "1rem",
            display: "flex",
            alignItems: "stretch",
            height: { xs: 200, sm: "auto", md: "auto" }
        }}
    />
)

export const PointsBox = ({ items, direction }) => (
    <Grid2
        size={{ xs: 12, sm: 6, md: 8 }}
        sx={{
            display: "flex",
            alignItems: "stretch"
        }}
    >
        <StarBulletsPointsWithHeading items={items} direction={direction} />
    </Grid2>
)

const CurriculumSection = ({ curriculumElyfData }) => {

    const benefitData1 = [
        {
            listItemTitle: "Clear Learning Outcomes",
            listItemContent:
                "Every grade has a defined checklist of “what the child must know,” making progress measurable and visible."
        },
        {
            listItemTitle: "Individual Attention",
            listItemContent:
                "Children learn at their own pace with plenty of revision and hands-on activities."
        },
        {
            listItemTitle: "Skill Mastery",
            listItemContent:
                "We ensure children don’t move ahead until they fully understand each concept."
        }
    ]

    const benefitData2 = [
        {
            listItemTitle: "Parent-Friendly",
            listItemContent:
                "Parents get clarity on what their child is learning and how they are progressing."
        },
        {
            listItemTitle: "Reduced Screen-Time",
            listItemContent:
                "Structured worksheets and activities keep children engaged in meaningful offline learning."
        },
        {
            listItemTitle: "Strong Transition Between Grades",
            listItemContent:
                "Children move to the next class with confidence because their basics are solid."
        }
    ]



    return (
        <Box>
            <Heading Heading="BENEFITS OF THE ELYF CURRICULUM" center />
            <CustomDivider />

            {/* SECTION 1 */}
            <Grid2 container>
                <ImageBox
                    //  img={EducationForLifeImages.CurriculumFrame1}
                    img={getImageUrl(curriculumElyfData?.benefits[0]?.imageUrl)}
                />
                <PointsBox items={curriculumElyfData?.benefits[0]?.list} />
            </Grid2>

            <CustomDivider />

            {/* SECTION 2 */}
            <Grid2 container>
                <PointsBox
                    items={curriculumElyfData?.benefits[1]?.list}
                    direction="row-reverse" />
                <ImageBox
                    img={getImageUrl(curriculumElyfData?.benefits[1]?.imageUrl)}
                // img={EducationForLifeImages.CurriculumFrame2}
                />
            </Grid2>
        </Box>
    )
}

export default CurriculumSection
